import React, { useState, useEffect } from 'react';
import { FiRefreshCw, FiCalendar, FiZap, FiCheckCircle, FiAlertTriangle,FiEdit2 ,FiLayers, FiSettings } from 'react-icons/fi';
import { FaShopify } from 'react-icons/fa';
import { FiTag, FiImage, FiClock, FiSmartphone, FiCode } from 'react-icons/fi';
import {FiExternalLink} from 'react-icons/fi';
import {   FiLink, FiChevronDown, FiChevronUp, FiCheck, FiX } from 'react-icons/fi';
import { BiMerge } from 'react-icons/bi';




export default function OnePageSEOPage(){
    // Sample data - replace with real API calls
    const [scanResults, setScanResults] = useState({
      thinContent: [
        { url: '/products/blue-tshirt', wordCount: 120, content: "Blue cotton t-shirt. Available in sizes S-XL." },
        { url: '/collections/summer', wordCount: 85, content: "Summer collection. New arrivals." }
      ],
      duplicateContent: [
        { 
          url1: '/products/hat-black', 
          url2: '/products/hat-dark', 
          similarity: 92,
          content1: "Black cotton hat with logo embroidery.",
          content2: "Dark cotton hat with logo embroidery."
        }
      ],
      headingIssues: [
        { url: '/collections/men', issues: ['missing_h1', 'h3_without_h2'] },
        { url: '/products/sneakers', issues: ['multiple_h1'] }
      ],
      keywordIssues: [
        { 
          url: '/products/backpack', 
          targetKeywords: ['eco backpack', 'sustainable bags'],
          foundKeywords: ['backpack'],
          density: 0.8
        }
      ],
      urlIssues: [
        { url: '/collections/123-summer?filter=price', issues: ['length', 'dynamic_params'] },
        { url: '/product/leather-BAG', issues: ['uppercase', 'stop_words'] }
      ]
    });
  
    const [activeTab, setActiveTab] = useState('thin');
    const [expandedItems, setExpandedItems] = useState({});
  
    const toggleExpand = (type, index) => {
      setExpandedItems(prev => ({
        ...prev,
        [`${type}-${index}`]: !prev[`${type}-${index}`]
      }));
    };
  
    // Color palette from your specification
    const colors = {
      rich_black: '#001219',
      midnight_green: '#005f73',
      dark_cyan: '#0a9396',
      tiffany_blue: '#94d2bd',
      vanilla: '#e9d8a6',
      gamboge: '#ee9b00',
      alloy_orange: '#ca6702',
      rust: '#bb3e03',
      rufous: '#ae2012',
      auburn: '#9b2226'
    };
  
    // AI Fix Actions
    const applyFix = (type, index) => {
      alert(`Applying ${type} fix to item ${index + 1}`);
      // In a real app, this would call your backend API
    };
  
    const generateHeading = (url) => {
      alert(`Generating SEO-friendly heading for ${url}`);
    };
  
    return (
      <div className="min-h-screen bg-gray-50">
        {/* Header */}
        <header className="bg-white shadow-sm">
          <div className="max-w-7xl mx-auto px-4 py-4 sm:px-6 lg:px-8 flex justify-between items-center">
            <div className="flex items-center space-x-2">
              <FaShopify className={`text-3xl`} style={{ color: colors.midnight_green }} />
              <span className="text-2xl font-bold" style={{ color: colors.rich_black }}>SEO AutoFix</span>
            </div>
            <button className="px-4 py-2 rounded-md text-white font-medium" 
                    style={{ background: `linear-gradient(135deg, ${colors.midnight_green}, ${colors.dark_cyan})` }}>
              Run New Scan
            </button>
          </div>
        </header>
  
        {/* Main Content */}
        <main className="max-w-7xl mx-auto px-4 py-8 sm:px-6 lg:px-8">
          {/* Summary Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
            <div className="bg-white rounded-lg shadow p-6 border-l-4" style={{ borderColor: colors.rufous }}>
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-medium text-gray-900">Thin Content</h3>
                <FiAlertTriangle className="text-xl" style={{ color: colors.rufous }} />
              </div>
              <p className="mt-2 text-3xl font-bold" style={{ color: colors.rich_black }}>
                {scanResults.thinContent.length}
              </p>
              <p className="mt-1 text-sm text-gray-500">Pages with &lt;300 words</p>
            </div>
  
            <div className="bg-white rounded-lg shadow p-6 border-l-4" style={{ borderColor: colors.alloy_orange }}>
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-medium text-gray-900">Duplicate Content</h3>
                <BiMerge className="text-xl" style={{ color: colors.alloy_orange }} />
              </div>
              <p className="mt-2 text-3xl font-bold" style={{ color: colors.rich_black }}>
                {scanResults.duplicateContent.length}
              </p>
              <p className="mt-1 text-sm text-gray-500">Similar content pairs</p>
            </div>
  
            <div className="bg-white rounded-lg shadow p-6 border-l-4" style={{ borderColor: colors.gamboge }}>
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-medium text-gray-900">Heading Issues</h3>
                <FiTag className="text-xl" style={{ color: colors.gamboge }} />
              </div>
              <p className="mt-2 text-3xl font-bold" style={{ color: colors.rich_black }}>
                {scanResults.headingIssues.length}
              </p>
              <p className="mt-1 text-sm text-gray-500">Missing/misused H1-H6 tags</p>
            </div>
  
            <div className="bg-white rounded-lg shadow p-6 border-l-4" style={{ borderColor: colors.dark_cyan }}>
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-medium text-gray-900">URL Issues</h3>
                <FiLink className="text-xl" style={{ color: colors.dark_cyan }} />
              </div>
              <p className="mt-2 text-3xl font-bold" style={{ color: colors.rich_black }}>
                {scanResults.urlIssues.length}
              </p>
              <p className="mt-1 text-sm text-gray-500">Poor URL structures</p>
            </div>
          </div>
  
          {/* Tabs */}
          <div className="border-b border-gray-200 mb-6">
            <nav className="-mb-px flex space-x-8">
              {[
                { id: 'thin', name: 'Thin Content', icon: FiAlertTriangle, color: colors.rufous },
                { id: 'duplicate', name: 'Duplicate Content', icon: BiMerge, color: colors.alloy_orange },
                { id: 'headings', name: 'Heading Issues', icon: FiTag, color: colors.gamboge },
                { id: 'keywords', name: 'Keyword Issues', icon: FiTag, color: colors.tiffany_blue },
                { id: 'urls', name: 'URL Issues', icon: FiLink, color: colors.dark_cyan }
              ].map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm flex items-center ${activeTab === tab.id ? `border-[${tab.color}] text-[${tab.color}]` : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`}
                  style={activeTab === tab.id ? { borderBottomColor: tab.color, color: tab.color } : {}}
                >
                  <tab.icon className="mr-2" />
                  {tab.name}
                  <span className="ml-2 bg-gray-100 rounded-full px-2 py-0.5 text-xs font-medium">
                    {scanResults[`${tab.id}Content`]?.length || scanResults[`${tab.id}Issues`]?.length || 0}
                  </span>
                </button>
              ))}
            </nav>
          </div>
  
          {/* Tab Content */}
          <div className="bg-white shadow rounded-lg overflow-hidden">
            {/* Thin Content */}
            {activeTab === 'thin' && (
              <div className="divide-y divide-gray-200">
                {scanResults.thinContent.map((item, index) => (
                  <div key={index} className="p-6">
                    <div className="flex justify-between items-start">
                      <div>
                        <h3 className="text-lg font-medium flex items-center">
                          <span className="w-5 h-5 rounded-full flex items-center justify-center mr-2" style={{ backgroundColor: colors.rufous, color: 'white' }}>
                            {index + 1}
                          </span>
                          <a href={item.url} target="_blank" rel="noopener noreferrer" className="hover:underline flex items-center">
                            {item.url} <FiExternalLink className="ml-1 text-sm" />
                          </a>
                        </h3>
                        <p className="mt-1 text-sm text-gray-500">
                          Word count: <span className="font-medium" style={{ color: colors.rufous }}>{item.wordCount}</span> (minimum 300 recommended)
                        </p>
                      </div>
                      <button 
                        onClick={() => toggleExpand('thin', index)}
                        className="p-1 rounded-md hover:bg-gray-100"
                      >
                        {expandedItems[`thin-${index}`] ? <FiChevronUp /> : <FiChevronDown />}
                      </button>
                    </div>
  
                    {expandedItems[`thin-${index}`] && (
                      <div className="mt-4 pl-7">
                        <div className="bg-gray-50 p-4 rounded-md mb-4">
                          <h4 className="text-sm font-medium mb-2">Current Content:</h4>
                          <p className="text-gray-700 italic">"{item.content}"</p>
                        </div>
  
                        <div className="bg-blue-50 p-4 rounded-md mb-4 border border-blue-100">
                          <h4 className="text-sm font-medium mb-2 flex items-center">
                            <FiRefreshCw className="mr-1" /> AI Suggestions:
                          </h4>
                          <ul className="list-disc pl-5 space-y-2 text-gray-700">
                            <li>Add product benefits: "Our blue t-shirt is made from 100% organic cotton for maximum comfort."</li>
                            <li>Include sizing details: "Fits true to size. Model is 6' tall wearing size Medium."</li>
                            <li>Add keywords: "soft blue t-shirt, casual cotton tee, everyday basic top"</li>
                          </ul>
                        </div>
  
                        <div className="flex space-x-3">
                          <button 
                            onClick={() => applyFix('thin_content', index)}
                            className="px-4 py-2 rounded-md text-white text-sm font-medium" 
                            style={{ backgroundColor: colors.dark_cyan }}
                          >
                            Auto-Expand Content
                          </button>
                          <button className="px-4 py-2 rounded-md border border-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-50">
                            Mark as Ignored
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
  
            {/* Duplicate Content */}
            {activeTab === 'duplicate' && (
              <div className="divide-y divide-gray-200">
                {scanResults.duplicateContent.map((item, index) => (
                  <div key={index} className="p-6">
                    <div className="flex justify-between items-start">
                      <div>
                        <h3 className="text-lg font-medium">
                          <span className="w-5 h-5 rounded-full flex items-center justify-center mr-2 " style={{ backgroundColor: colors.alloy_orange, color: 'white' }}>
                            {index + 1}
                          </span>
                          Similarity: {item.similarity}%
                        </h3>
                        <div className="mt-2 grid grid-cols-1 md:grid-cols-2 gap-4">
                          <div>
                            <a href={item.url1} target="_blank" rel="noopener noreferrer" className="text-sm hover:underline flex items-center">
                              {item.url1} <FiExternalLink className="ml-1 text-xs" />
                            </a>
                          </div>
                          <div>
                            <a href={item.url2} target="_blank" rel="noopener noreferrer" className="text-sm hover:underline flex items-center">
                              {item.url2} <FiExternalLink className="ml-1 text-xs" />
                            </a>
                          </div>
                        </div>
                      </div>
                      <button 
                        onClick={() => toggleExpand('duplicate', index)}
                        className="p-1 rounded-md hover:bg-gray-100"
                      >
                        {expandedItems[`duplicate-${index}`] ? <FiChevronUp /> : <FiChevronDown />}
                      </button>
                    </div>
  
                    {expandedItems[`duplicate-${index}`] && (
                      <div className="mt-4 pl-7">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">
                          <div className="bg-gray-50 p-4 rounded-md">
                            <h4 className="text-sm font-medium mb-2">Page 1 Content:</h4>
                            <p className="text-gray-700 italic">"{item.content1}"</p>
                          </div>
                          <div className="bg-gray-50 p-4 rounded-md">
                            <h4 className="text-sm font-medium mb-2">Page 2 Content:</h4>
                            <p className="text-gray-700 italic">"{item.content2}"</p>
                          </div>
                        </div>
  
                        <div className="bg-blue-50 p-4 rounded-md mb-4 border border-blue-100">
                          <h4 className="text-sm font-medium mb-2 flex items-center">
                            <FiRefreshCw className="mr-1" /> Recommended Actions:
                          </h4>
                          <ul className="list-disc pl-5 space-y-2 text-gray-700">
                            <li><strong>Merge products:</strong> Combine these variants into a single product with color options</li>
                            <li><strong>Add canonical tag:</strong> Set one page as canonical to avoid duplicate content penalties</li>
                            <li><strong>Differentiate content:</strong> Rewrite one page to focus on different aspects (e.g., "Black Hat for Hiking" vs "Dark Hat for Urban Wear")</li>
                          </ul>
                        </div>
  
                        <div className="flex space-x-3">
                          <button 
                            onClick={() => applyFix('merge_pages', index)}
                            className="px-4 py-2 rounded-md text-white text-sm font-medium" 
                            style={{ backgroundColor: colors.dark_cyan }}
                          >
                            Merge Pages
                          </button>
                          <button 
                            onClick={() => applyFix('canonical_tag', index)}
                            className="px-4 py-2 rounded-md text-white text-sm font-medium" 
                            style={{ backgroundColor: colors.midnight_green }}
                          >
                            Add Canonical Tag
                          </button>
                          <button className="px-4 py-2 rounded-md border border-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-50">
                            Mark as Ignored
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
  
            {/* Heading Issues */}
            {activeTab === 'headings' && (
              <div className="divide-y divide-gray-200">
                {scanResults.headingIssues.map((item, index) => (
                  <div key={index} className="p-6">
                    <div className="flex justify-between items-start">
                      <div>
                        <h3 className="text-lg font-medium flex items-center">
                          <span className="w-5 h-5 rounded-full flex items-center justify-center mr-2" style={{ backgroundColor: colors.gamboge, color: 'white' }}>
                            {index + 1}
                          </span>
                          <a href={item.url} target="_blank" rel="noopener noreferrer" className="hover:underline flex items-center">
                            {item.url} <FiExternalLink className="ml-1 text-sm" />
                          </a>
                        </h3>
                        <div className="mt-2 flex flex-wrap gap-2">
                          {item.issues.map((issue, i) => (
                            <span 
                              key={i} 
                              className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                              style={{ 
                                backgroundColor: issue === 'missing_h1' ? `${colors.vanilla}50` : 
                                              issue === 'multiple_h1' ? `${colors.tiffany_blue}50` : 
                                              `${colors.gamboge}50`,
                                color: colors.rich_black
                              }}
                            >
                              {issue === 'missing_h1' && 'Missing H1'}
                              {issue === 'multiple_h1' && 'Multiple H1s'}
                              {issue === 'h3_without_h2' && 'H3 without H2'}
                            </span>
                          ))}
                        </div>
                      </div>
                      <button 
                        onClick={() => toggleExpand('heading', index)}
                        className="p-1 rounded-md hover:bg-gray-100"
                      >
                        {expandedItems[`heading-${index}`] ? <FiChevronUp /> : <FiChevronDown />}
                      </button>
                    </div>
  
                    {expandedItems[`heading-${index}`] && (
                      <div className="mt-4 pl-7">
                        <div className="mb-6">
                          <h4 className="text-sm font-medium mb-2">Current Heading Structure:</h4>
                          <div className="bg-gray-50 p-4 rounded-md font-mono text-sm">
                            {item.url === '/collections/men' ? (
                              <>
                                <div className="text-red-500">❌ No H1 tag found</div>
                                <div className="ml-4 text-green-600">✓ H2: "Best Sellers"</div>
                                <div className="ml-4 text-green-600">✓ H2: "New Arrivals"</div>
                                <div className="ml-8 text-yellow-600">⚠️ H3: "Summer Styles" (without parent H2)</div>
                              </>
                            ) : (
                              <>
                                <div className="text-red-500">❌ Multiple H1 tags:</div>
                                <div className="ml-4">"Premium Sneakers"</div>
                                <div className="ml-4">"Nike Air Max"</div>
                              </>
                            )}
                          </div>
                        </div>
  
                        <div className="bg-blue-50 p-4 rounded-md mb-4 border border-blue-100">
                          <h4 className="text-sm font-medium mb-2 flex items-center">
                            <FiRefreshCw className="mr-1" /> AI Suggestions:
                          </h4>
                          {item.url === '/collections/men' ? (
                            <ul className="list-disc pl-5 space-y-2 text-gray-700">
                              <li><strong>Add H1:</strong> "Men's Clothing Collection | [Brand Name]"</li>
                              <li><strong>Restructure:</strong> Move "Summer Styles" under "New Arrivals" H2</li>
                            </ul>
                          ) : (
                            <ul className="list-disc pl-5 space-y-2 text-gray-700">
                              <li><strong>Consolidate H1:</strong> "Nike Air Max Premium Sneakers"</li>
                              <li><strong>Convert extras to H2:</strong> "Product Details", "Reviews", "Shipping Info"</li>
                            </ul>
                          )}
                        </div>
  
                        <div className="flex space-x-3">
                          <button 
                            onClick={() => generateHeading(item.url)}
                            className="px-4 py-2 rounded-md text-white text-sm font-medium" 
                            style={{ backgroundColor: colors.dark_cyan }}
                          >
                            Generate Headings
                          </button>
                          <button 
                            onClick={() => applyFix('heading_structure', index)}
                            className="px-4 py-2 rounded-md text-white text-sm font-medium" 
                            style={{ backgroundColor: colors.midnight_green }}
                          >
                            Auto-Restructure
                          </button>
                          <button className="px-4 py-2 rounded-md border border-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-50">
                            Mark as Ignored
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
  
            {/* Keyword Issues */}
            {activeTab === 'keywords' && (
              <div className="divide-y divide-gray-200">
                {scanResults.keywordIssues.map((item, index) => (
                  <div key={index} className="p-6">
                    <div className="flex justify-between items-start">
                      <div>
                        <h3 className="text-lg font-medium flex items-center">
                          <span className="w-5 h-5 rounded-full flex items-center justify-center mr-2" style={{ backgroundColor: colors.tiffany_blue, color: colors.rich_black }}>
                            {index + 1}
                          </span>
                          <a href={item.url} target="_blank" rel="noopener noreferrer" className="hover:underline flex items-center">
                            {item.url} <FiExternalLink className="ml-1 text-sm" />
                          </a>
                        </h3>
                        <div className="mt-2">
                          <p className="text-sm">
                            Keyword density: <span style={{ color: item.density < 1 ? colors.rufous : colors.dark_cyan }} className="font-medium">{item.density}%</span> (ideal 1-2%)
                          </p>
                        </div>
                      </div>
                      <button 
                        onClick={() => toggleExpand('keyword', index)}
                        className="p-1 rounded-md hover:bg-gray-100"
                      >
                        {expandedItems[`keyword-${index}`] ? <FiChevronUp /> : <FiChevronDown />}
                      </button>
                    </div>
  
                    {expandedItems[`keyword-${index}`] && (
                      <div className="mt-4 pl-7">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">
                          <div className="bg-gray-50 p-4 rounded-md">
                            <h4 className="text-sm font-medium mb-2">Target Keywords:</h4>
                            <div className="flex flex-wrap gap-2">
                              {item.targetKeywords.map((kw, i) => (
                                <span key={i} className="bg-blue-100 text-blue-800 px-2 py-1 rounded text-xs">
                                  {kw}
                                </span>
                              ))}
                            </div>
                            <p className="mt-3 text-xs text-gray-500">
                              Based on your SEO strategy and competitor analysis
                            </p>
                          </div>
                          <div className="bg-gray-50 p-4 rounded-md">
                            <h4 className="text-sm font-medium mb-2">Found Keywords:</h4>
                            <div className="flex flex-wrap gap-2">
                              {item.foundKeywords.map((kw, i) => (
                                <span key={i} className="bg-green-100 text-green-800 px-2 py-1 rounded text-xs">
                                  {kw}
                                </span>
                              ))}
                              {item.foundKeywords.length === 0 && (
                                <span className="text-gray-500 text-xs">None detected</span>
                              )}
                            </div>
                            <p className="mt-3 text-xs text-gray-500">
                              Appears {item.foundKeywords.length} times in content
                            </p>
                          </div>
                        </div>
  
                        <div className="bg-blue-50 p-4 rounded-md mb-4 border border-blue-100">
                          <h4 className="text-sm font-medium mb-2 flex items-center">
                            <FiRefreshCw className="mr-1" /> Optimization Suggestions:
                          </h4>
                          <ul className="list-disc pl-5 space-y-2 text-gray-700">
                            <li>
                              <strong>Add to title:</strong> "Eco-Friendly {item.targetKeywords[0]} | Sustainable Backpacks"
                            </li>
                            <li>
                              <strong>First paragraph:</strong> "Our {item.targetKeywords[0]} is made from recycled materials..."
                            </li>
                            <li>
                              <strong>LSI keywords:</strong> Consider adding "environmentally friendly", "recycled materials", "zero waste"
                            </li>
                          </ul>
                        </div>
  
                        <div className="flex space-x-3">
                          <button 
                            onClick={() => applyFix('keyword_optimization', index)}
                            className="px-4 py-2 rounded-md text-white text-sm font-medium" 
                            style={{ backgroundColor: colors.dark_cyan }}
                          >
                            Auto-Optimize
                          </button>
                          <button className="px-4 py-2 rounded-md border border-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-50">
                            Mark as Ignored
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
  
            {/* URL Issues */}
            {activeTab === 'urls' && (
              <div className="divide-y divide-gray-200">
                {scanResults.urlIssues.map((item, index) => (
                  <div key={index} className="p-6">
                    <div className="flex justify-between items-start">
                      <div>
                        <h3 className="text-lg font-medium flex items-center">
                          <span className="w-5 h-5 rounded-full flex items-center justify-center mr-2" style={{ backgroundColor: colors.dark_cyan, color: 'white' }}>
                            {index + 1}
                          </span>
                          <a href={item.url} target="_blank" rel="noopener noreferrer" className="hover:underline flex items-center">
                            {item.url} <FiExternalLink className="ml-1 text-sm" />
                          </a>
                        </h3>
                        <div className="mt-2 flex flex-wrap gap-2">
                          {item.issues.map((issue, i) => (
                            <span 
                              key={i} 
                              className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                              style={{ 
                                backgroundColor: issue === 'length' ? `${colors.vanilla}50` : 
                                              issue === 'dynamic_params' ? `${colors.tiffany_blue}50` : 
                                              `${colors.dark_cyan}50`,
                                color: colors.rich_black
                              }}
                            >
                              {issue === 'length' && 'Too long (89 chars)'}
                              {issue === 'dynamic_params' && 'Dynamic parameters'}
                              {issue === 'uppercase' && 'Uppercase letters'}
                              {issue === 'stop_words' && 'Stop words'}
                            </span>
                          ))}
                        </div>
                      </div>
                      <button 
                        onClick={() => toggleExpand('url', index)}
                        className="p-1 rounded-md hover:bg-gray-100"
                      >
                        {expandedItems[`url-${index}`] ? <FiChevronUp /> : <FiChevronDown />}
                      </button>
                    </div>
  
                    {expandedItems[`url-${index}`] && (
                      <div className="mt-4 pl-7">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">
                          <div className="bg-gray-50 p-4 rounded-md">
                            <h4 className="text-sm font-medium mb-2">Current URL:</h4>
                            <div className="font-mono text-sm break-all">{item.url}</div>
                            <div className="mt-3">
                              <h5 className="text-xs font-medium mb-1">Issues:</h5>
                              <ul className="list-disc pl-5 text-xs text-gray-700">
                                {item.issues.includes('length') && <li>Too long (search engines truncate after ~60 chars)</li>}
                                {item.issues.includes('dynamic_params') && <li>Dynamic parameters hurt SEO and readability</li>}
                                {item.issues.includes('uppercase') && <li>Mixed case causes duplicate content issues</li>}
                                {item.issues.includes('stop_words') && <li>Stop words ("a", "the") add no value</li>}
                              </ul>
                            </div>
                          </div>
                          <div className="bg-blue-50 p-4 rounded-md border border-blue-100">
                            <h4 className="text-sm font-medium mb-2">Suggested URL:</h4>
                            {item.url === '/collections/123-summer?filter=price' ? (
                              <>
                                <div className="font-mono text-sm text-green-600">/collections/summer-essentials</div>
                                <div className="mt-3">
                                  <h5 className="text-xs font-medium mb-1">Improvements:</h5>
                                  <ul className="list-disc pl-5 text-xs text-gray-700">
                                    <li>Removed ID number (123)</li>
                                    <li>Removed dynamic parameter (?filter=price)</li>
                                    <li>Added descriptive keyword ("essentials")</li>
                                    <li>Length: 25 chars (was 89)</li>
                                  </ul>
                                </div>
                              </>
                            ) : (
                              <>
                                <div className="font-mono text-sm text-green-600">/product/leather-bag</div>
                                <div className="mt-3">
                                  <h5 className="text-xs font-medium mb-1">Improvements:</h5>
                                  <ul className="list-disc pl-5 text-xs text-gray-700">
                                    <li>Lowercased all letters</li>
                                    <li>Removed stop words</li>
                                    <li>Simplified structure</li>
                                  </ul>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
  
                        <div className="bg-blue-50 p-4 rounded-md mb-4 border border-blue-100">
                          <h4 className="text-sm font-medium mb-2 flex items-center">
                            <FiRefreshCw className="mr-1" /> Implementation Notes:
                          </h4>
                          <ul className="list-disc pl-5 space-y-2 text-gray-700 text-sm">
                            <li>This change requires setting up 301 redirects to preserve link equity</li>
                            <li>Update all internal links pointing to the old URL</li>
                            <li>Submit updated sitemap to Google Search Console</li>
                          </ul>
                        </div>
  
                        <div className="flex space-x-3">
                          <button 
                            onClick={() => applyFix('url_rewrite', index)}
                            className="px-4 py-2 rounded-md text-white text-sm font-medium" 
                            style={{ backgroundColor: colors.dark_cyan }}
                          >
                            Update URL
                          </button>
                          <button 
                            onClick={() => applyFix('redirect_setup', index)}
                            className="px-4 py-2 rounded-md text-white text-sm font-medium" 
                            style={{ backgroundColor: colors.midnight_green }}
                          >
                            Setup 301 Redirect
                          </button>
                          <button className="px-4 py-2 rounded-md border border-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-50">
                            Mark as Ignored
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </main>
  
        {/* Footer */}
        <footer className="bg-white mt-12 border-t border-gray-200">
          <div className="max-w-7xl mx-auto px-4 py-8 sm:px-6 lg:px-8">
            <p className="text-center text-sm text-gray-500">
              © {new Date().getFullYear()} SEO AutoFix. All rights reserved.
            </p>
          </div>
        </footer>
      </div>
    );
  };
  